import timers from './timers';
import { registerStore } from '../api/axios-wrapper';

import store from './store';

timers(store);
registerStore(store);

export default store;
